import React, { useEffect, useState } from "react";
import { TreeViewMachineStructureFlatMap } from "./tree-our-node/tree-view-machine-structure-flat-map";
import { TreeViewForFilteredDataMachineStructureOurNode } from "./tree-our-node/tree-view-filtered-data-machine-structure-our-node";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { TreeViewForNoOurNodeMachineStructureDragAndDrop } from "./tree-our-node/tree-view-no-our-node-machine-structure-drag-and-drop";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";

const TreeViewMachineStructure = () => {
  const [isNewMachineStructureEmpty, setIsNewMachineStructureEmpty] =
    useState(false);

  const initialStructureNodeset = getInitialStructureNodeset();

  const [showFilterPanel, setShowFilterPanel] = useState(false);

  const machineStructureNodeset = getMachineStructureNodeset();

  useEffect(() => {
    if (
      machineStructureNodeset.getFlatMap() === null ||
      machineStructureNodeset.getFlatMap().size <= 1
    ) {
      setIsNewMachineStructureEmpty(true);
    }
  }, []);

  useEffect(() => {
    const updateFlatMap = () => {
      const flatMap = machineStructureNodeset.getFlatMap();

      if (flatMap === null || flatMap.size <= 1) {
        setIsNewMachineStructureEmpty(true);

        // set rootnode to untransfered
        const initialStructureRootNode = initialStructureNodeset.getRootNode();
        if (initialStructureRootNode) {
          initialStructureRootNode.transfered = false;
        }
        initialStructureNodeset.selectedNodeIds = new Set();
      } else {
        setIsNewMachineStructureEmpty(false);
      }
    };

    machineStructureNodeset.addObserver(updateFlatMap);

    return () => {
      machineStructureNodeset.removeObserver(updateFlatMap);
    };
  }, [machineStructureNodeset]);

  useEffect(() => {
    const updateFilterFlatMap = () => {
      setShowFilterPanel(machineStructureNodeset.getShowFilterPanel());
    };

    machineStructureNodeset.addObserver(updateFilterFlatMap);

    return () => {
      machineStructureNodeset.removeObserver(updateFilterFlatMap);
    };
  }, [machineStructureNodeset]);

  const conditions = [
    {
      condition: !isNewMachineStructureEmpty && showFilterPanel,
      component: <TreeViewForFilteredDataMachineStructureOurNode />,
    },
    {
      condition: !isNewMachineStructureEmpty && !showFilterPanel,
      component: <TreeViewMachineStructureFlatMap />,
    },
    {
      condition: isNewMachineStructureEmpty,
      component: <TreeViewForNoOurNodeMachineStructureDragAndDrop />,
    },
  ];

  return <>{conditions.find(({ condition }) => condition)?.component}</>;
};

export default TreeViewMachineStructure;
